import React, { useState } from "react";
import "./CoursePayment.css";
import { Modal } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import { useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import paymentConditions from "./paymentConditions";
import Alert from "../../Components/Alert/Alert";
import ProgramBanner from "../../Components/ProgramBanner/ProgramBanner";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import { useBaseUrl } from "../../ApiContext";

export default function CoursePayment() {
  const location = useLocation();
  const courseData = location.state?.courseData;
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [showCommingSoonAlert, setShowCommingSoonAlert] = useState(false);
  const [showPaymentAlert, setShowPaymentAlert] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showConditions, setShowConditions] = useState(false);

  console.log("c", courseData);

  const showConditionsHandler = () => {
    setShowConditions(true);
  };

  const hideConditionsHandler = () => {
    setShowConditions(false);
  };

  const acceptConditions = () => {
    setIsChecked(!isChecked);
  };

  const showAlertModal = () => {
    setShowCommingSoonAlert(true);
    setTimeout(() => {
      setShowCommingSoonAlert(false);
    }, 2000);
  };

  const openPaymentPage = async () => {
    try {
      const response = await Axios.post(
        `${baseUrl}/payment/buy?${
          courseData.label === "diet" ? "diet_product" : "exercise_product"
        }=${courseData.id}`,
        {},
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      const url = response.data.url;
      if (url && url.includes("zarinpal")) {
        window.location.href = url;
      }
    } catch (error) {
      console.log("Error during opening zarinpal", error);
    }
    setShowPaymentAlert(true);
    setTimeout(() => {
      setShowPaymentAlert(false);
    }, 2000);
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <h3 className="pageTitle horizontalBorder">
            {courseData && courseData.name}
          </h3>
          <div className="payment centeredFlex">
            <div className="paymentTop">
              {courseData && <ProgramBanner {...courseData} />}
            </div>
            <div className="paymentMiddle">
              <div className="paymentMethods centeredFlex">
                <div className="internetPayment centeredFlex">
                  <div></div>
                  <span>پرداخت اینترنتی</span>
                </div>
                <div
                  className="payWithCoins centeredFlex"
                  onClick={showAlertModal}
                >
                  <img src="/images/smallCoin.svg" alt="coin icon" />
                  <span>پرداخت با سکه</span>
                </div>
              </div>
              <p className="paymentText">پرداخت با تمام کارت های عضو شتاب</p>
            </div>
            <div className="paymentBottom">
              <button
                className={`paymentBtn ${isChecked ? "" : "disabledBtn"}`}
                onClick={openPaymentPage}
              >
                پرداخت ( {courseData && courseData.price} ) تومان
              </button>
              <label
                className="conditionsContainer centeredFlex horizontalBorder"
                onClick={showConditionsHandler}
              >
                <input
                  type="checkbox"
                  className="radioBtn"
                  checked={isChecked}
                  onChange={acceptConditions}
                />
                <span className="customAcceptConditionsBtn"></span>
                <span className="paymentConditionsLink">
                  قوانین را خوانده ام و موافقم
                </span>
              </label>
            </div>
            <Modal
              show={isChecked && showConditions}
              dialogClassName="questionModal"
              contentClassName="customModalContent"
              onHide={hideConditionsHandler}
            >
              <div>
                <MdClose
                  className="closeAnswerIcon"
                  onClick={hideConditionsHandler}
                />
              </div>
              <div className="answerModal">
                {paymentConditions.map((condition, index) => (
                  <div key={index} className="answerPart">
                    <div className="pinkSquare"></div>
                    <p>{condition}</p>
                  </div>
                ))}
              </div>
              <button
                className="conditionsModalBtn"
                onClick={hideConditionsHandler}
              >
                تایید
              </button>
            </Modal>
          </div>
          <Alert alertText="به زودی" showAlert={showCommingSoonAlert} />
          <Alert
            alertText="در حال انتقال به صفحه پرداخت..."
            showAlert={showPaymentAlert}
          />
        </div>
      </div>
    </div>
  );
}
